// extracted by mini-css-extract-plugin
export default {"group":"Checkbox_group__sTjT0","error":"Checkbox_error__DBpTB","label":"Checkbox_label__O-SB1"};